import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import FirstLanguageDropDownViewModel from '../ViewModels/FirstLanguageViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IFirstLanguageDropDownProps {
    setFirstLanguage?: (event) => void;
    firstLanguage: string | undefined;
    disabled: boolean;
}

interface IFirstLanguageDropDownState {
    model: FirstLanguageDropDownViewModel[];
    loaded: boolean;
}

class FirstLanguageDropDown extends Component<IFirstLanguageDropDownProps & WithStyles<typeof styles>, IFirstLanguageDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetFirstLanguages').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultFirstLanguageVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label="What is your child's first language? *"
                name="firstLanguage"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.firstLanguage}
                onChange={this.props.disabled ? undefined : this.props.setFirstLanguage}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(FirstLanguageDropDown);